export default __webpack_public_path__ + "static/media/fiolet_mobile-internet.550c7987.svg";